module.exports = __webpack_public_path__ + "img/step_cright_img02.961b49d7.png";